import actionCreatorFactory, { Action } from 'typescript-fsa'
import { Collection, ScreenSection } from '../api/types'
import { MapRoute } from 'mytours-read-api-typescript'

const actionCreator = actionCreatorFactory('Maps')

export interface MapRouteResult {
	linkedId: number
	linkedType: MapRoute.LinkedTypeEnum
	mapRouteId: number
	mapRouteVersion: number
	mapRoute: any[]
	language: string
}
export type MapRouteResultAction = Action<MapRouteResult>
export const loadedMapRouteFromDisk = actionCreator<MapRouteResult>('LOADED_MAP_ROUTE_FROM_DISK')

export interface RequestParams {
	item: Collection | ScreenSection
	linkedType: MapRoute.LinkedTypeEnum
	language: string
	accountId?: number
}
export type LoadMapRoutesParams = Action<RequestParams>
export const loadMapRoutes = actionCreator<RequestParams>('LOAD_MAP_ROUTES')
